module.exports = __webpack_public_path__ + "static/media/servicios_energia.6316fc3d.jpg";